import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=ea12aa0c&scoped=true&"
import script from "./AddContact.vue?vue&type=script&lang=js&"
export * from "./AddContact.vue?vue&type=script&lang=js&"
import style0 from "./AddContact.vue?vue&type=style&index=0&id=ea12aa0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea12aa0c",
  null
  
)

export default component.exports